const units = {}

units["hero/rogue"] = {
    "jobKey": "hero/dagger",
    "jobName": "Dagger",
    "skills": ["inflict-damage"],
    "element": "fire",
    "attacktype": "steel",
    "attackrange": 2,
    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "imageUrl": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/rogue_bad.png"),
    "imageSize": "contained",
}

units["hero/berserker"] = {
    "jobKey": "hero/berserker",
    "jobName": "Hammer",
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 30,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "imageUrl": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/berserker_bad.png"),
    "imageSize": "contained",
}

units["hero/calvary"] = {
    "jobKey": "hero/calvary",
    "jobName": "calvary",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 40,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "facts": [
        "Can move 3 tiles"
    ],

    "imageUrl": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/cavalry_bad.png"),
    "imageSize": "contained",
}

units["hero/cleric"] = {
    "jobKey": "hero/cleric",
    "jobName": "Priest",
    "skills": ["inflict-damage", "restore-health"],
    "element": "water",
    "attacktype": "magic",
    "attackrange": 2,
    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "facts": [
        "Can heal"
    ],

    "imageUrl": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/cleric_bad.png"),
    "imageSize": "contained",

    "portraits": {
        "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/B-neutral.png"),
        "happy": require("@frog/source/assets/images/chess-tactics/portraits/newer/B-happy.png"),
        "serene": require("@frog/source/assets/images/chess-tactics/portraits/newer/B-serene.png"),
        "sly": require("@frog/source/assets/images/chess-tactics/portraits/newer/B-sly.png"),
    }
}

units["hero/swordlord"] = {
    "jobKey": "hero/swordlord",
    "jobName": "Swordlord",
    "skills": ["inflict-damage"],
    "element": "fire",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "facts": [
        "Can rally an ally to move again."
    ],

    "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/lord").default,
    "imageSize": "buffered",
}

units["hero/bladesinger"] = {
    "jobKey": "hero/bladesinger",
    "jobName": "Blademaster",
    "skills": ["inflict-damage"],
    "properties": ["lifesteal"],
    "element": "fire",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 2,
    "power": 20,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,

    "facts": [
        "Heals self for 5hp after attacking.",
    ],

    "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/bladesinger").default,
    "allysprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/bladesinger").default,
    "imageSize": "buffered",
}

units["hero/firefist"] = {
    "jobKey": "hero/firefist",
    "jobName": "Monk",
    "skills": ["inflict-damage"],
    "properties": ["forceful"],
    "element": "fire",
    "attacktype": "magic",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 30,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "facts": [
        "Pushes enemy a tile after attacking."
    ],

    "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/mage").default,
    "allysprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/mage").default,
    "imageSize": "buffered",
}

units["hero/archer"] = {
    "jobKey": "hero/archer",
    "jobName": "Archer",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "steel",
    "attackrange": 2,
    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "facts": [
        "Can attack from 2 tiles away."
    ],

    "imageUrl": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/archer/archer-idle-0.png"),
    // "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/archer").default,
    "imageSize": "buffered",
}

units["hero/sniper"] = {
    "jobKey": "hero/sniper",
    "jobName": "Sniper",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "steel",
    "attackrange": {"min": 1, "max": 10, "orthogonal": true, "diagonal": false},
    "moverange": 2,
    "maxhealth": 30,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "facts": [
        "Can attack any tile orthogonally."
    ],

    "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/sniper").default,
    "allysprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/sniper").default,
    "imageSize": "buffered",
}

units["hero/ranger"] = {
    "jobKey": "hero/ranger",
    "jobName": "Ranger",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "steel",
    "attackrange": 2,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 30,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "facts": [
        "Can move 3 tiles a turn."
    ],

    "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/ranger").default,
    "allysprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/ranger").default,
    "imageSize": "buffered",
}

units["hero/knight"] = {
    "jobKey": "hero/knight",
    "jobName": "Knight",
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxhealth": 20,
    "power": 20,
    "defense": 5,
    "resistance": 0,

    "facts": [
        "Has high defense, decreasing all attacks by 5 damage.",
        "Can heal."
    ],

    "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/knight").default,
    "imageSize": "buffered",
}

units["hero/general"] = {
    "jobKey": "hero/general",
    "jobName": "General",
    "skills": ["inflict-damage"],
    "properties": ["counter"],
    "element": "earth",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxhealth": 30,
    "power": 20,
    "defense": 5,
    "resistance": 0,

    "facts": [
        "+20 damage to all counterattacks.",
        // "Has high defense, decreasing all attacks by 5 damage.",
    ],

    "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/general").default,
    "allysprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/general").default,
    "imageSize": "buffered",
}

units["hero/paladin"] = {
    "jobKey": "hero/paladin",
    "jobName": "Paladin",
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 30,
    "power": 20,
    "defense": 5,
    "resistance": 0,

    "facts": [
        "Slow no longer! Can move now 3 tiles.",
        // "Has high defense, decreasing all attacks by 5 damage.",
    ],

    "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/enemy/paladin").default,
    "allysprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/paladin").default,
    "imageSize": "buffered",

    "portraits": {
        "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/EK-neutral.png"),
        "happy": require("@frog/source/assets/images/chess-tactics/portraits/newer/EK-happy.png"),
        "smug": require("@frog/source/assets/images/chess-tactics/portraits/newer/EK-smug.png"),
    }
}

export default units
